import "highcharts/modules/drilldown";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React from "react";
import { dashboardColors } from "routes/utils";


interface Supplier {
  name: string;
  value: number;
  color: string;
}

interface SupplierChartProps {
  data: { name: string; value: number }[];
  isFetching: boolean;
}

  const colors = dashboardColors;

export const SupplierChart: React.FC<SupplierChartProps> = ({ data, isFetching }:any) => {
  if (isFetching) {
    return <p>Loading Supplier Data...</p>;
  }

  // const suppliers: Supplier[] = 
  //   data?.purchaseProgressData.length > 0
  //     ? data?.purchaseProgressData?.map((item:any, index:number) => ({
  //         name: item.name,
  //         value: item.value,
  //         color: colors[index % colors.length],
  //       }))
  //     : [{ name: "No Data", value: 0, color: "#ccc" }];

      const suppliers: Supplier[] =
  data?.purchaseProgressData && Array.isArray(data.purchaseProgressData) && data.purchaseProgressData.length > 0
    ? data.purchaseProgressData.map((item: any, index: number) => ({
        name: item?.name ?? "Unknown",
        value: item?.value ?? 0,
        color: colors[index % colors.length],
      }))
    : [{ name: "No Data", value: 0, color: "#ccc" }];

  const options: Highcharts.Options = {
    chart: { type: "bar", height: 120 },
    title: { text: undefined },
    xAxis: { visible: false },
    yAxis: { visible: false, max: 100 },
    legend: { enabled: false },
    credits: { enabled: false },
    tooltip: { 
       headerFormat: '<span style="font-size: 14px"><b>{point.name}</b></span><br/>',
       pointFormat: "<b>{point.percentage:.1f}%</b> ({point.y} kg)" },
     plotOptions: {
      series: { stacking: "percent", borderWidth: 0 },
      bar: { dataLabels: { enabled: true, format: "{point.percentage:.1f}%" } },
    },
    series: suppliers.map((s) => ({
      type: "bar",
      name: s.name,
       data: [
      {
        y: s.value,     // numeric value
        name: s.name,   // this enables {point.name} in tooltip
      },
    ],
      color: s.color,
    })),
  };

   
  
  return (
    <div style={{ width: "100%", maxWidth: 500, margin: "0 auto" }}>
      <h2>Purchase Supplier</h2>
      <HighchartsReact highcharts={Highcharts} options={options} />

      <div style={{ marginTop: 10 }}>
        {suppliers.length > 0 && suppliers.map((s, idx) => (
          <div
            key={idx}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 8,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span
                style={{
                  display: "inline-block",
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: s.color,
                }}
              />
              <span>{s.name}</span>
            </div>
            <span>{s.value} kg</span>
          </div>
        ))}
      </div>
    </div>
  );
};
